export default (api) => {
    return {
        index: options => api.get('lessons', options),
        indexSchedules: options => api.get('lesson_schedules', options),
        get: (lesson_id, options) => api.get(`lessons/${lesson_id}`, options),
        create: (data, options) => api.post('lessons', data, options),
        update: (lesson_id, data, options) => api.put(`lessons/${lesson_id}`, data, options),
        delete: (lesson_id, options) => api.delete('lessons/' + lesson_id, options),
        toggleAnswerKeys: (lesson_id, options) => api.patch(`lessons/${lesson_id}/answer-keys`, options),
        toggleMarkAsDone: (lesson_id, options) => api.patch(`lessons/${lesson_id}/done`, options),
        transfer: (lesson_id, user_id, data, options) => api.patch(`lessons/${lesson_id}/transfer/${user_id}`, data, options),
        coClasses: (options) => api.get('lessons/co-teaching', options),
        pause: (lesson_id, options) => api.patch(`lessons/${lesson_id}/pause`, options),
        unpause: (lesson_id, options) => api.patch(`lessons/${lesson_id}/unpause`, options),
        setStreamsIndex: (lesson_id, index, options) => api.patch(`lessons/${lesson_id}/streams/index`, {index}, options),
        updateMode: (lesson_id, mode, options) => api.patch(`lessons/${lesson_id}/mode`, {mode}, options),
        assignUsers: (lesson_id, data, options) => api.post(`lessons/${lesson_id}/streams`, data, options),
        assignStudents: (lesson_id, data, options) => api.post(`lessons/${lesson_id}/students`, data, options),
        getCleverClassStudents: (class_id, options) => api.get(`clever/classes/${class_id}/students`, options),
        joinLesson: (code, data, options) => api.post(`lessons/${code}/join`, data, options),
        joinForce: (code, data, options) => api.post(`lessons/${code}/join/force`, data, options),
        joinPD: (code, data, options) => api.post(`teacher/pd/join/${code}`, data, options),
        getCleverClasses: (options) => api.get(`clever/classes`, options),
        lowerAllHands: (lesson_id, options) => api.patch(`lessons/${lesson_id}/lower_all_hands`, options),
        getPDCertificate: (lesson_code, options) => api.get(`lessons/${lesson_code}/certificate`, options)
    }
}
